import React, { useState } from "react";
import styled from "styled-components";
import { Table, Input, Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import {
  useQueryParam,
  NumberParam,
  withDefault,
} from "use-query-params";

import { LIMIT_PAGE } from "constants/index";

import { INCOMING_ORDERS_COLUMNS } from "./constants";
import { incomingOrders } from "./mock";

const Container = styled.div`
  padding: 12px;
`;

const StyledRow = styled(Row)`
  padding-bottom: 12px;
`;

const FlexCol = styled(Col)`
  display: flex;
  justify-content: space-between;
`;

const { Search } = Input;

const IncomingOrders = () => {
  const { t } = useTranslation();
  const [page, setPage] = useQueryParam("page", withDefault(NumberParam, 1));
  const [search, setSearch] = useState("");

  const incomingOrdersData = incomingOrders.filter(
    ({ location_id, waiter, status, amount }) =>
      `${location_id}_${waiter}_${status}_${amount}`.includes(
        search.trim().toLowerCase(),
      ),
  );

  return (
    <Container>
      <StyledRow>
        <FlexCol>
          <Col span={4}>
            <Search
              placeholder={t("QuickSearch")}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
        </FlexCol>
      </StyledRow>
      <Table
        rowKey="id"
        pagination={{
          current: page,
          onChange: setPage,
          pageSize: LIMIT_PAGE,
        }}
        columns={INCOMING_ORDERS_COLUMNS}
        dataSource={incomingOrdersData}
      />
    </Container>
  );
};

export default IncomingOrders;
